import { render, staticRenderFns } from "./PostsCreate.vue?vue&type=template&id=91037b80&"
import script from "./PostsCreate.vue?vue&type=script&lang=js&"
export * from "./PostsCreate.vue?vue&type=script&lang=js&"
import style0 from "./PostsCreate.vue?vue&type=style&index=0&id=91037b80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports